__turbopack_context__.v({
  "trailContainer": "style-module-scss-module__NFMR8G__trailContainer",
  "trailItem": "style-module-scss-module__NFMR8G__trailItem",
});
